import { ListWorkspacesResponse } from './types';
import { axiosMeedioClient } from '../client';
import { dedupeInFlight } from '../inFlightDedupe';

const WORKSPACES_DEDUPE_KEY = 'apiKeys:workspaces';

/**
 * Resolves the NestJS workspace UUID required by the API key routes by matching
 * the selected workspace's Matrix room id against `GET /workspaces`.
 * Returns `null` when no workspace matches the given Matrix room id.
 */
export const resolveWorkspaceUuid = async (workspaceMatrixRoomId: string): Promise<string | null> => {
  const data = await dedupeInFlight(WORKSPACES_DEDUPE_KEY, async () => {
    const response = await axiosMeedioClient.get<ListWorkspacesResponse>('/workspaces');
    return response.data;
  });

  const match = data.workspaces.find((workspace) => workspace.matrix_room_id === workspaceMatrixRoomId);
  return match?.id ?? null;
};
